import { useQuery } from '@tanstack/react-query';

import { branchesApi } from '../branches.api';
import type { BranchListResponse } from '../branches.types';

/**
 * Hook que carrega as filiais disponíveis pro tenant. Cache de 10min —
 * lista raramente muda. Em caso de erro silencioso (branch ACL ou
 * credenciais incorretas), a UI mostra fallback ("erro empresas — clique
 * pra retry").
 */
export function useBranches() {
  return useQuery<BranchListResponse>({
    queryKey: ['tenants', 'branches'],
    queryFn: () => branchesApi.list(),
    staleTime: 10 * 60_000,
    // Não retry em 401/403 — guard cuida. Retry só em 5xx/network.
    retry: (failureCount, err) => {
      const status = (err as { response?: { status?: number } })?.response?.status;
      if (status === 401 || status === 403) return false;
      return failureCount < 1;
    },
  });
}
